// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"512e7d0e","212":"4af02abf","388":"61f31ea5","396":"96957c8d","421":"25b1d5ea","655":"d3e4275c"}[chunkId] + ".chunk.css";
};